module.exports = __webpack_public_path__ + "static/hero_patterns_sp-c40fabafab29f4ed0e94a9205452215c.png";